var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lat && _vm.lng)?_c('div',[_c('GmapMap',{attrs:{"center":_vm.center,"zoom":15,"map-type-id":"roadmap"}},[_c('GmapMarker',{attrs:{"position":_vm.center,"animation":_vm.animation}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }